import * as Yup from "yup";

export const indicatorSchema = Yup.object().shape({
  status: Yup.string("Debe ser una cadena de caracteres")
    .oneOf(["executed", "unexecuted"])
    .required("Seleccione el estado"),

  name: Yup.string("Debe ser una cadena de caracteres")
    .min(1, "No puede tener menos de 1 caracter")
    .max(50, "No puede tener más de 50 caracteres")
    .required("Ingrese el nombre del indicador"),

  description: Yup.string("Debe ser una cadena de caracteres")
    .min(1, "No puede tener menos de 1 caracter")
    .max(200, "No puede tener más de 200 caracteres")
    .required("Ingrese la descripción"),
});
